import React from 'react';
import { Box, Text, Image, Button, VStack, HStack, Icon } from '@chakra-ui/react';
import { FaCheckCircle } from 'react-icons/fa';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);
const MotionImage = motion(Image);
const MotionText = motion(Text);
const MotionButton = motion(Button);

const Banner: React.FC = () => {
  return (
    <MotionBox
      display="flex"
      flexDirection={'column'}
      alignItems="center"
      justifyContent="space-between"
      padding={5}
      mb='10px'
      backgroundColor="white"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <MotionBox
        display="flex"
        flexDirection={'column'}
        alignItems="center"
        justifyContent="center"
        marginTop={{ base: 5, md: 0 }}
        initial={{ x: -100 }}
        animate={{ x: 0 }}
        transition={{ duration: 1 }}
      >
        <MotionImage
          src="/b2.png"
          w="290px"
          marginRight={5}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.8,
            delay: 0.5,
            ease: [0, 0.71, 0.2, 1.01]
          }}
        />
      </MotionBox>
      <VStack
        spacing={5}
        alignItems={{ base: 'center', md: 'flex-start' }}
        textAlign={{ base: 'left', md: 'left' }}
      >
        <MotionText
          fontSize="2xl"
          fontWeight="bold"
          initial={{ y: -20 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.5 }}
          pl='5'
          pr='5'
        >
          The Family Doctor App Is The Easiest Way To Manage Your Health
        </MotionText>
        <VStack alignItems="flex-start" spacing={3} pl='5'
          pr='5'>
          <HStack>
            <Icon as={FaCheckCircle} color="red.500" mr="5px" />
            <MotionText
              initial={{ x: -20 }}
              animate={{ x: 0 }}
              transition={{ duration: 0.5 }}
            >
              Book appointments for yourself or a family member online 24/7
            </MotionText>
          </HStack>
          <HStack>
            <Icon as={FaCheckCircle} color="red.500" mr="5px" />
            <MotionText
              initial={{ x: -20 }}
              animate={{ x: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Add them to your calendar
            </MotionText>
          </HStack>
          <HStack>
            <Icon as={FaCheckCircle} color="red.500" mr="5px" />
            <MotionText
              initial={{ x: -20 }}
              animate={{ x: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              Get reminders
            </MotionText>
          </HStack>
          <HStack>
            <Icon as={FaCheckCircle} color="red.500" mr="5px" />
            <MotionText
              initial={{ x: -20 }}
              animate={{ x: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              Online check-in and queue information
            </MotionText>
          </HStack>
          <HStack>
            <Icon as={FaCheckCircle} color="red.500" mr="5px" />
            <MotionText
              initial={{ x: -20 }}
              animate={{ x: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              Important Health Updates
            </MotionText>
          </HStack>
        </VStack>
        <HStack spacing={3} >
          <MotionButton
            as="a"
            href="https://apps.apple.com/au/app/family-doctor/id1553864135"
            target="_blank"
            rel="noopener noreferrer"
            bg="#000000"
            w='140px'
            h='40px'
            boxShadow='md'
            _hover={{ bg: "#000000" }}
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              duration: 0.8,
              delay: 0.5,
              ease: [0, 0.71, 0.2, 1.01]
            }}
          >
            <Image src="/db1.png" w='200px' />
          </MotionButton>
          <MotionButton
            as="a"
            href="https://play.google.com/store/apps/details?id=au.com.hotdoc.familydoctor&pli=1"
            target="_blank"
            rel="noopener noreferrer"
            bg="#000000"
            w='140px'
            h='40px'
            boxShadow='md'
            _hover={{ bg: "#000000" }}
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              duration: 0.8,
              delay: 0.6,
              ease: [0, 0.71, 0.2, 1.01]
            }}
          >
            <Image src="/db2.png" />
          </MotionButton>
        </HStack>
      </VStack>
    </MotionBox>
  );
};

export default Banner;
